import { configureStore } from '@reduxjs/toolkit';
import { activitiesSlice } from './slices/activities';
import { batchesSlice } from './slices/batches';
import { coursesSlice } from './slices/courses';
import { groupsSlice } from './slices/groups';
import { materialsSlice } from './slices/materials';
import { reasonsSlice } from './slices/reasons/';
import { sizesSlice } from './slices/sizes/sizesSlice';
import { subActivitiesSlice } from './slices/subActivities';
import { transactionsSlice } from './slices/transactions';
import { workOrderSlice } from './slices/workOrder/workOrderSlice';

export const store = configureStore({
  reducer: {
    activities: activitiesSlice.reducer,
    batches: batchesSlice.reducer,
    courses: coursesSlice.reducer,
    groups: groupsSlice.reducer,
    materials: materialsSlice.reducer,
    subActivities: subActivitiesSlice.reducer,
    reasons: reasonsSlice.reducer,
    sizes: sizesSlice.reducer,
    transactions: transactionsSlice.reducer,
    workOrder: workOrderSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware()
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
